
import { createContext } from 'react';
import { AuthContextType } from './types';

// Create the context with a default undefined value
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
